// extracted by mini-css-extract-plugin
export var colOne = "styles-module--colOne--4a582";
export var colThree = "styles-module--colThree--6338b";
export var colTwo = "styles-module--colTwo--d0391";
export var threeColTable = "styles-module--threeColTable--72840";
export var threeColTableContainer = "styles-module--threeColTableContainer--087fb";
export var threeColTableDiv = "styles-module--threeColTableDiv--444bb";
export var title = "styles-module--title--c90df";